// Module
var code = `<div class="profile-body">
  <div class="tab-menu" ng-if="!\$ctrl.singlePage">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#cpr_tab_base_data" data-toggle="tab" ng-click="\$ctrl.setActiveTab('cpr_tab_base_data')">
            <span ng-if="\$ctrl.profile.customerType === 'INDIVIDUAL'">
              <i ng-if="\$ctrl.individualDataForm.\$invalid || \$ctrl.cooperativeForm.\$invalid" class="icon icon-warning-sign"></i>
              Individual Data
            </span>
            <span ng-if="\$ctrl.profile.customerType === 'CORPORATE'">
              <i ng-if="\$ctrl.corporateDataForm.\$invalid || \$ctrl.cooperativeForm.\$invalid" class="icon icon-warning-sign"></i>
              Corporate Data
            </span>
        </a>
      </li>
      <li><a data-target="#cpr_tab_documents" data-toggle="tab" ng-click="\$ctrl.setActiveTab('cpr_tab_documents')">
        <span><i ng-if="\$ctrl.documentsForm.\$invalid" class="icon icon-warning-sign"></i>Documents</span>
      </a></li>
      <li>
        <a data-target="#cpr_tab_addresses" data-toggle="tab" ng-click="\$ctrl.setActiveTab('cpr_tab_addresses')">
          <span><i ng-if="\$ctrl.addressesForm.\$invalid" class="icon icon-warning-sign"></i>Addresses</span>
        </a></li>
      <li><a data-target="#cpr_tab_income" data-toggle="tab" ng-click="\$ctrl.setActiveTab('cpr_tab_income')">
        <span><i ng-if="\$ctrl.incomeForm.\$invalid" class="icon icon-warning-sign"></i>
          {{\$ctrl.module === 'agent' ? 'Business information' : 'Income'}}
        </span>
      </a></li>
      <li ng-if="\$ctrl.module !== 'agent'"><a data-target="#cpr_tab_related" data-toggle="tab" ng-click="\$ctrl.setActiveTab('cpr_tab_related')">
        <span><i ng-if="\$ctrl.relatedPeopleForm.\$invalid" class="icon icon-warning-sign"></i>Related People</span>
      </a></li>
      <li ng-if="\$ctrl.module !== 'agent'"><a data-target="#cpr_tab_advanced" data-toggle="tab" ng-click="\$ctrl.setActiveTab('cpr_tab_advanced')">
        <span><i ng-if="\$ctrl.advancedForm.\$invalid" class="icon icon-warning-sign"></i>Advanced</span>
      </a></li>
      <li ng-if="\$ctrl.module !== 'agent' && \$ctrl.isCifProfileHistoryEnabled"><a data-target="#cpr_tab_history" data-toggle="tab" ng-click="\$ctrl.setActiveTab('cpr_tab_history')">
        <span>History</span>
      </a></li>
    </ul>
  </div>

  <form name="\$ctrl.mainForm">

    <div class="tab-content">
      <div id="cpr_tab_base_data"
           ng-class="{'tab-pane active': !\$ctrl.singlePage}">
        <customer-profile-individual-data ng-if="\$ctrl.profile.customerType == 'INDIVIDUAL'"
                                          profile="\$ctrl.profile"
                                          edit-mode="\$ctrl.editMode"
                                          ng-form="\$ctrl.individualDataForm"
                                          active-tab="\$ctrl.activeTab"
                                          on-name-change="\$ctrl.resetWatchlistVerification()"
                                          on-watchlist-verify="\$ctrl.verifyWatchlist(input)"
                                          module="\$ctrl.module"></customer-profile-individual-data>
        <customer-profile-corporate-data ng-if="\$ctrl.profile.customerType == 'CORPORATE'"
                                         profile="\$ctrl.profile"
                                         edit-mode="\$ctrl.editMode"
                                         active-tab="\$ctrl.activeTab"
                                         on-name-change="\$ctrl.resetWatchlistVerification()"
                                         on-watchlist-verify="\$ctrl.verifyWatchlist(input)"
                                         ng-form="\$ctrl.corporateDataForm"></customer-profile-corporate-data>

        <ng-form name="\$ctrl.cooperativeForm">
          <div class="form-column" ng-if="\$ctrl.propertyConfigService.visible('customer', 'cooperative_data', 'membership_type')">
            <form-section form-title="'Cooperative data'">
              <form-section-field field-title="'Membership Type'">
                <select
                  ng-model="\$ctrl.profile.membershipTypeId"
                  ng-required="\$ctrl.propertyConfigService.required('customer', 'cooperative_data', 'membership_type')"
                  ng-disabled="!\$ctrl.editMode"
                  ng-options="entry.id as entry.description for entry in \$ctrl.dict.MEMBERSHIP_TYPE"></select>
              </form-section-field>
            </form-section>
          </div>
        </ng-form>

      </div>

      <div id="cpr_tab_documents"
           ng-class="{'tab-pane': !\$ctrl.singlePage}"
           ng-if="\$ctrl.singlePage ? (\$ctrl.editMode || \$ctrl.profile.idDocuments.length > 0) : true">
        <div class="form-header no-print" ng-if="\$ctrl.singlePage">Documents</div>
        <customer-profile-documents id-documents="\$ctrl.profile.idDocuments"
                                    profile="\$ctrl.profile"
                                    edit-mode="\$ctrl.editMode"
                                    ng-form="\$ctrl.documentsForm"
                                    module="\$ctrl.module"></customer-profile-documents>
      </div>

      <div id="cpr_tab_addresses"
           ng-class="{'tab-pane': !\$ctrl.singlePage}"
           ng-if="\$ctrl.singlePage ? (\$ctrl.editMode || \$ctrl.profile.addresses.length > 0) : true">
        <div class="form-header no-print" ng-if="\$ctrl.singlePage">Addresses</div>
        <customer-profile-addresses addresses="\$ctrl.profile.addresses"
                                    edit-mode="\$ctrl.editMode"
                                    ng-form="\$ctrl.addressesForm"
                                    module="\$ctrl.module"></customer-profile-addresses>
      </div>

      <div id="cpr_tab_income"
           ng-class="{'tab-pane': !\$ctrl.singlePage}"
           ng-if="\$ctrl.singlePage ? (\$ctrl.editMode || \$ctrl.profile.incomeSources.length > 0) : true">
        <div class="form-header no-print" ng-if="\$ctrl.singlePage">Income</div>
        <customer-profile-income profile="\$ctrl.profile"
                                 edit-mode="\$ctrl.editMode"
                                 ng-form="\$ctrl.incomeForm"
                                 module="\$ctrl.module"></customer-profile-income>
      </div>

      <div id="cpr_tab_related"
           ng-class="{'tab-pane': !\$ctrl.singlePage}"
           ng-if="\$ctrl.singlePage ? (\$ctrl.editMode || \$ctrl.profile.relatedCustomers.length > 0 || \$ctrl.profile.relatedNonCustomers.length > 0) : true">
        <div class="form-header no-print" ng-if="\$ctrl.singlePage">Related People</div>
        <customer-profile-related-people profile="\$ctrl.profile"
                                         edit-mode="\$ctrl.editMode"
                                         ng-form="\$ctrl.relatedPeopleForm"
                                         min-related-people="\$ctrl.getMinRelatedCustomers()"></customer-profile-related-people>
      </div>

      <div id="cpr_tab_advanced"
           ng-class="{'tab-pane': !\$ctrl.singlePage}"
           ng-if="\$ctrl.singlePage ? \$ctrl.editMode : true">
        <div class="form-header no-print" ng-if="\$ctrl.singlePage">Advanced</div>
        <custom-field-input
          group="'CUSTOMER'"
          ng-form="\$ctrl.advancedForm"
          available-custom-fields="\$ctrl.availableCustomFields"
          assigned-category-ids="\$ctrl.profile.categoryIds"
          custom-field-values="\$ctrl.profile.customFieldValues"
          edit-mode="\$ctrl.editMode"
          customer-id="\$ctrl.profile.id">
        </custom-field-input>
      </div>

      <div id="cpr_tab_history" ng-class="{'tab-pane': !\$ctrl.singlePage}" ng-if="\$ctrl.isCifProfileHistoryEnabled">
        <div class="form-header no-print" ng-if="\$ctrl.singlePage">History</div>
        <div ng-if="\$ctrl.profile.id">
          <profile-history-table prop="\$ctrl.profile"></profile-history-table>
        </div>
      </div>
    </div>
  </form>

  <div class="tab-content summary-actions" ng-if="\$ctrl.activeTab !== 'cpr_tab_history'">
    <div class="buttons" ng-if="!\$ctrl.editMode" ng-transclude="editDisabled"></div>
    <div class="buttons" ng-transclude="alwaysVisible"></div>

    <div ng-if="!\$ctrl.hideDefaultButtons && \$ctrl.profile.id" class="buttons">
      <div ng-if="!\$ctrl.editMode && \$ctrl.profile.status !== 'CLOSED'">
        <button type="button" class="btn btn-primary" ng-click="\$ctrl.enableEditMode()">
          Edit customer profile
        </button>
      </div>

      <div ng-if="\$ctrl.editMode && \$ctrl.profile.status !== 'CLOSED'">
        <button type="button"
                class="btn btn-warning"
                ng-if="!\$ctrl.profile.shouldUpdateProfile"
                ng-click="\$ctrl.cancelEdit()">Cancel edit
        </button>
        <button type="submit" class="btn btn-primary"
                command-access="UpdateCustomer"
                ng-disabled="\$ctrl.mainForm.\$invalid"
                ng-click="\$ctrl.updateCustomer()">
          Confirm changes
        </button>
      </div>
    </div>

    <div ng-if="!\$ctrl.hideDefaultButtons && !\$ctrl.profile.id" class="buttons">
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.reset(false)">Reset</button>
      <button type="submit" class="btn btn-primary" ng-click="\$ctrl.createCustomer()"
              command-access="CreateCustomer"
              ng-disabled="\$ctrl.mainForm.\$invalid || \$ctrl.creatingCustomer || \$ctrl.isCustomerFailedRiskProfiling()">
        Save
      </button>
    </div>

  </div>
</div>

<modal on-api-ready="\$ctrl.onSubcategoryModalApiReady">
  <modal-header>
    <h3>Select subcategories to include in Automatic Risk Profile computation</h3>
  </modal-header>
  <modal-body>
    <form name="\$ctrl.form" style="min-height: 400px;">
      <table class="table table-style table-hover profile-body__table">
        <thead>
        <th class="no-column-header">No.</th>
        <th>Risk category</th>
        <th>Subcategory</th>
        </thead>
        <tbody>
        <tr ng-repeat="category in \$ctrl.riskCategoriesForManualSelection">
          <td>{{\$index + 1}}.</td>
          <td class="category-name">{{category.name}}</td>
          <td ng-if="category.assignTo === 'LINKED_CONDITIONS'">
            <select ng-disabled="true"></select>
          </td>
          <td ng-if="category.assignTo !== 'LINKED_CONDITIONS' && category.selectorType === 'SINGLE_SELECT'">
            <select ng-model="category.selectedSubcategoryIds"
                    ng-options="entry.id as entry.description for entry in category.valuesForSelection">
            </select>
          </td>
          <td ng-if="category.assignTo !== 'LINKED_CONDITIONS' && category.selectorType === 'MULTI_SELECT'">
            <multiselect items="category.valuesForSelection"
                         label-property="'description'"
                         value-property="'description'"
                         ng-model="category.selectedSubcategoryIds">
            </multiselect>
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </modal-body>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/profile/body/customer-profile-body.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;